import { getComponentCssUrl, getGlobalCssUrl } from "../../Global/loadDependency"

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavHeaderTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl("NavHeaderContextual--wc.css")}" rel="stylesheet" />
`
  return t
}

// Getter function for template
const getTemplateNavHeaderStyles = () => createNavHeaderTemplate()
export { getTemplateNavHeaderStyles }
